import React, { useState, useEffect } from 'react';

const Criacao = () => {
	return <div className='text-3xl '> Criacao DE VIOLENCIA</div>;
};

export default Criacao;
